export default __webpack_public_path__ + "static/media/Scratch.6ab3cd04.webp";